import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useState } from "react";
import { Link } from "../Link/index.js";
import { RedoCountdown } from "./RedoCountdown/index.js";
const CODE_RESEND_DELAY_MS = 59000;
const Redo = (t0)=>{
    const $ = c(15);
    const { label, action, after: t1, timestamp, disabled: t2 } = t0;
    const after = void 0 === t1 ? CODE_RESEND_DELAY_MS : t1;
    const disabled = void 0 === t2 ? false : t2;
    let t3;
    if ($[0] !== after || $[1] !== timestamp) {
        t3 = ()=>(null != timestamp ? timestamp : Date.now()) + after;
        $[0] = after;
        $[1] = timestamp;
        $[2] = t3;
    } else t3 = $[2];
    const [endDate, setEndDate] = useState(t3);
    let t4;
    if ($[3] !== endDate) {
        t4 = ()=>Date.now() < endDate;
        $[3] = endDate;
        $[4] = t4;
    } else t4 = $[4];
    const [isTimerVisible, setIsTimerVisible] = useState(t4);
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>{
            setIsTimerVisible(_temp);
        };
        $[5] = t5;
    } else t5 = $[5];
    const toggleTimerVisibility = t5;
    let t6;
    if ($[6] !== action || $[7] !== after) {
        t6 = ()=>{
            setEndDate(Date.now() + after);
            toggleTimerVisibility();
            action();
        };
        $[6] = action;
        $[7] = after;
        $[8] = t6;
    } else t6 = $[8];
    const handleSendAgainClick = t6;
    let t7;
    if ($[9] !== disabled || $[10] !== endDate || $[11] !== handleSendAgainClick || $[12] !== isTimerVisible || $[13] !== label) {
        t7 = isTimerVisible ? /*#__PURE__*/ jsx(RedoCountdown, {
            label: label,
            disabled: disabled,
            finalDate: endDate,
            toggleTimerVisibility: toggleTimerVisibility
        }) : /*#__PURE__*/ jsx(Link, {
            onClick: handleSendAgainClick,
            disabled: disabled,
            stroke: false,
            children: label
        });
        $[9] = disabled;
        $[10] = endDate;
        $[11] = handleSendAgainClick;
        $[12] = isTimerVisible;
        $[13] = label;
        $[14] = t7;
    } else t7 = $[14];
    return t7;
};
function _temp(prevShowTimer) {
    return !prevShowTimer;
}
export { CODE_RESEND_DELAY_MS, Redo };
